import { getDefaultCurrency } from '@/utils/currencyConfig';

export interface DefferedTransfer {
  id: string;
  userId: string;
  account: string;
  recipientAccountNumber: string;
  currency: string;
  amount: number;
  fee: number;
  reason: string;
  status: string;
  externalTransfer?: boolean;
  bankCode?: string;
  branchCode?: string;
  currencyId?: string;
  executionDateTime: string;
  notificationEnabled: boolean;
  fromAccount: string;
  type: string;
  recipientName?: string;
}

export interface SwiftTransfer {
  id: string;
  cbsReference: string;
  senderName: string;
  accountNumber: string;
  currency: string;
  amount: number;
  beneficiaryName: string;
  swiftCode: string;
  iban: string;
  status: 'PENDING' | 'APPROVED' | 'DECLINED';
  rejectReason: string;
  createdAt: string;
  validatedAt: string;
  files: ImageMeta[];
}

export interface ImageMeta {
  file?: File;
  name: string;
  originalFilename: string;
  size: string;
  type: string;
}

export interface TransferFromCSV {
  bankCode: string;
  branch: string;
  accountNumber: string;
  accountKey: string;
  deviceIso: string;
  amount: string;
  reason: string;
  isInternal: boolean;
}

export interface Transfer {
  bankName: string;
  branchCode: string;
  beneficiaryBranchCode: string;
  showCalendar: boolean;
  exchangeOn: boolean;
  reason: string;
  amount: {
    origin: string;
    exchange: string;
  };
  currency: {
    from: string;
    to: string;
  };
  accNumber: string;
  fetchAccount: boolean;
  fetchInProgress: boolean;
  recipientName: string;
  firstName: string;
  lastName: string;
  showExecuteDate: boolean;
  executeDate: string;
  time: string;
  sendNotify: boolean;
}

export const getInitialTransfer = (): Transfer => {
  const defaultCurrency = getDefaultCurrency();
  return {
    bankName: '',
    branchCode: '',
    beneficiaryBranchCode: '',
    showCalendar: false,
    exchangeOn: false,
    reason: '',
    amount: {
      origin: '',
      exchange: '',
    },
    currency: {
      from: defaultCurrency,
      to: defaultCurrency,
    },
    accNumber: '',
    fetchAccount: false,
    fetchInProgress: false,
    recipientName: '',
    firstName: '',
    lastName: '',
    showExecuteDate: false,
    executeDate: '',
    time: '00:00',
    sendNotify: false,
  };
};

export interface NraPayment {
  refNo: string;
  amount: string;
  currency: string;
  fee: number;
  taxName: string;
  taxDescription: string;
}

export interface TransferValidationRequest {
  accountId: string;
  recipientAccountNumber: string;
  recipientName: string;
  amount: number;
  reason: string;
  executionDateTime?: string | null;
  notificationEnabled: boolean;
  externalTransfer: boolean;
  bankCode: string;
  branchCode: string;
  currencyId: string;
  cbsOperationType: string;
}

type InvalidTransferInfo = {
  transferOrder: number;
  reason: string;
};

export interface TransferValidationResponse {
  invalidTransferInfos: InvalidTransferInfo[];
  isValid: boolean;
  message: string;
}

export interface TransferEntry {
  accountId: string;
  recipientAccountNumber: string;
  amount: number;
  currencyId: string;
  bankCode: string;
  branchCode: string;
}

export interface CheckDuplicateRequest {
  transfers: TransferEntry[];
}

export interface DuplicateEntry {
  recipientAccountNumber: string;
  recipientName: string;
  amount: number;
  currency: string;
  status: string;
  createdAt: string;
  executionAt: string;
}

export interface CheckDuplicateResponse {
  duplicates: DuplicateEntry[];
}

export interface SwiftTransferEntry {
  amount: number;
  iban: string;
  swift: string;
  currency: string;
  beneficiaryName: string;
  routingNumber?: string;
}

export interface CheckDuplicateSwiftRequest {
  swiftTransfers: SwiftTransferEntry[];
}
